import React from "react";

const UnorderListIcon = ({
  size = 8,
  fill = "#002D9F",
}: {
  size?: number;
  fill?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 8 8"
      fill="none"
    >
      <circle cx="4" cy="4" r="4" fill={fill} />
    </svg>
  );
};

export default UnorderListIcon;
